<app-sidebar></app-sidebar>
<main class="dashboard-main">
  <div class="dashboard-content">
    <div class="dashboard-header" style="display:flex; align-items:center; justify-content:space-between;">
      <div>
        <h1 class="dashboard-title">Purchase Limits</h1>
        <div class="dashboard-welcome">Monitor and manage retailer purchase limits</div>
      </div>
    </div>
    <hr>

    <!-- Purchase Limits Summary Cards -->
    <div class="purchase-limits-summary-cards">
      <div class="summary-card">
        <div class="summary-value">{{getTotalRetailers()}}</div>
        <div class="summary-title">Total Retailers</div>
      </div>
      <div class="summary-card">
        <div class="summary-value active">{{getActiveLimits()}}</div>
        <div class="summary-title">Active Limits</div>
      </div>
      <div class="summary-card">
        <div class="summary-value maxed">{{getMaxedOut()}}</div>
        <div class="summary-title">Maxed Out</div>
      </div>
      <div class="summary-card">
        <div class="summary-value">₹{{getTotalLimits() | number}}</div>
        <div class="summary-title">Total Limits</div>
      </div>
    </div>

    <div class="my-6 flex flex-col md:flex-row gap-3">
      <input type="text" placeholder="Search by retailer or distributor..." [(ngModel)]="searchTerm" #searchBox
        (input)="onSearch(searchBox.value)"
        class="flex-1 md:w-96 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500" />
    </div>
    <div class="overflow-x-auto md:overflow-x-visible rounded-lg">
    <table class="modern-table min-w-full">
      <thead>
        <tr style="background:#f5f5f5;">
          <th>Retailer</th>
          <th>Distributor</th>
          <th>Current Limit</th>
          <th>Used Amount</th>
          <th>Available</th>
          <th>Utilization</th>
          <th>Last Updated</th>
          <!-- <th>Actions</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pl of purchaseLimits">
          <td>{{pl.retailer_name}}</td>
          <td>{{pl.distributor_name}}</td>
          <td>₹{{pl.current_limit | number}}</td>
          <td>₹{{pl.used_amount | number}}</td>
          <td>₹{{getAvailableAmount(pl) | number}}</td>
          <td>
            <div class="utilization-container">
              <div class="utilization-bar-wrapper">
                <div [class]="'utilization-bar ' + getUtilizationClass(pl)"
                  [style.width.%]="getUtilizationPercentage(pl)"></div>
              </div>
              <span class="utilization-percent"
                [class]="getUtilizationClass(pl)">{{getUtilizationPercentage(pl)}}%</span>
            </div>
          </td>
          <td>{{formatDate(pl.last_updated)}}</td>
          <!-- <td>
            <span class="action-btn" (click)="editPurchaseLimit(pl)" title="Edit">
              <i class="fas fa-edit"></i>
            </span>
          </td> -->
        </tr>
        <tr *ngIf="!loading && purchaseLimits.length === 0">
          <td colspan="8" style="text-align:center; padding:24px; color:#888;">No purchase limits found</td>
        </tr>
        <tr *ngIf="loading">
          <td colspan="8" style="text-align:center; padding:24px; color:#888;">Loading...</td>
        </tr>
      </tbody>
    </table>
    </div>
    <div *ngIf="pagination.totalPages > 1" class="mt-6 flex flex-col sm:flex-row justify-center items-center gap-3 flex-wrap">
      <button (click)="goToPage(pagination.page - 1)" [disabled]="!pagination.hasPrev"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Prev</button>
      <span class="text-sm text-gray-600">Page {{pagination.page}} of {{pagination.totalPages}}</span>
      <button (click)="goToPage(pagination.page + 1)" [disabled]="!pagination.hasNext"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Next</button>
    </div>
  </div>
</main>